export default {
  path: '/support',
  meta: {
    layout: 'main',
    notificationsPath: 'support',
    breadcrumb: {
      linkTo: 'support',
      linkText: 'Техническая поддержка'
    }
  },
  component: () => import('../views/support/Index.vue'),
  children: [
    {
      path: '',
      name: 'support',
      component: () => import('../views/support/Support.vue'),
      meta: {
        layout: 'main'
      }
    },
    {
      path: 'requests/:supportRequestId',
      component: () => import('../views/support/SupportRequest.vue'),
      name: 'supportRequest',
      props: true,
      meta: {
        layout: 'main',
        paramName: 'supportRequestId',
        excludeFromMenu: true,
        breadcrumb: {
          storePath: 'support.requests'
        }
      }
    }
  ]
}